export default function routes($stateProvider){


    $stateProvider
        .state('appView.headerSection', {
            url: '?section',
            views: {
                "header-section@appView":{
                    template: require('./index.html')
                }
            }
        })
}

routes.$inject = ['$stateProvider'];


// WEBPACK FOOTER //
// ./src/app/views/header-content/header-content.routes.js